import { useEffect, useState, useRef } from "react";
import {
  Container,
  Col,
  Row,
  Overlay,
  Button,
  Popover,
  Modal,
  Image,
} from "react-bootstrap";
import { connect } from "react-redux";
import { Formik, Form } from "formik";
import { VzPageContainer } from "../../../layouts/VzPageContainer";
import FormikControl from "../../../layouts/Input/FormikControl";
import storage from "../../../apis/Storage";
import Moment from "react-moment";
import {
  GET_DISTRIBUTOR_DDL,
  GET_ADDJOB_DISTRIBUTIONCENTER_DDL,
  GET_LENDER_DDL,
} from "../../../Types";
import { formatDate, renderCell, renderHeader, toCommaSeparated } from "../../../utilities/FUNCTIONS";
import ServerSideDataTable from "../../../layouts/DataTables/ServerSideDataTable/ServerSideDataTable";
import {
  getDisbursementFormList,
  updateDisbursementForm,
  cancelLoan,
  rejectedLoanIntrnalApply,
  applyNewLoan
} from "./DisbursementFormListActions";
import { getDropdownList, getDropdownListByPost } from "../../Shared/dropdownListActions";
import { Link } from "react-router-dom";
import axios from "../../../apis/Api";
import * as Yup from "yup";
import PlaceholderImage from "../../../assets/Images/placeholder-image.png";
import { useDispatch } from "react-redux";
import { uploadFile } from "../../../utilities/ImageUpload";
import { showLoading, hideLoading } from "react-redux-loading-bar";
import { toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";
import { isPermittedPage } from "../../../apis/Utility";
import NewLoanForm from "./ApplyNewLoan/NewLoanForm";
import { getImageExtensions } from "../../../utilities/FUNCTIONS";
import { AllowOnlyAlphaNumericWithDash } from "../../../utilities/Validations";

const DisbursementFormList = (props) => {
  const dispatch = useDispatch();
  const userRights = JSON.parse(storage.get("_userRights"));
  const [target, setTarget] = useState(null);
  const [show, setShow] = useState(false);
  const [readOnly, setReadOnly] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const ref = useRef(null);
  // pagination states
  const [currentIndex, setCurrentIndex] = useState();
  const [currentPageNo, setCurrentPageNo] = useState(0);
  const [currentPageSize, setCurrentPageSize] = useState(5);
  const [searchText, setSearchText] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);
  const [distributorList, setDistributorList] = useState([]);
  const [distCenterList, setdistCenterList] = useState([]);
  const [isApplyFilter, setIsApplyFilter] = useState(false);
  const [lenderOptions, setLenderOptions] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [stockImage, setStockImage] = useState(null);
  const [invoiceImage, setInvoiceImage] = useState(null);

  const imgUploadRef = useRef();
  const [selectedImg, setSelectedImg] = useState("");
  const [selectedDisbursement, setSelectedDisbursement] = useState(null);
  const [originalDisbursementData, setOriginalDisbursementData] =
    useState(null);

  const [showNewLoanPopup, setshowNewLoanPopup] = useState(false);

  const [initialValues] = useState({
    id: "",
    date: "",
    vizId: "",
    financer: "",
    externalId: "",
    loanDisplayName: "",
    shopCode: "",
    shopName: "",
    repaymentStatus: "",
    loanStatus: "",
    reason: "",
    responseDateTime: "",
    invoiceDate: "",
    invoiceNumber: "",
    invoiceAmount: "",
    deliveryMan: "",
    financeRequired: "",
    tenor: "",
    profit: 0,
    netPayable: 0,
    dueDate: "",
    stockImageUrl: "",
    invoiceImageUrl: "",
  });

  const [disbursementDetail, setDisbursementDetail] = useState(initialValues);

  const [filter, setfilter] = useState({
    distId: [],
    distCenterId: [],
    financerId: [],
    vizId: "",
    invoiceNo: "",
    loanId: "",
    status: null,
    fromDate: new Date(),
    toDate: new Date(),
    pageNo: 0,
    searchText: null,
  });

  const openFilterModal = (event) => {
    setShow(!show);
    setTarget(event.target);
  };

  function commonReset(reset = true) {
    if (reset) {
      setSearchText("");
      setdistCenterList([]);
      setfilter({
        distId:
          userRights != null && userRights?.userType == "DistributorUser"
            ? toCommaSeparated(filter.distributor)
            : [],
        distCenterId: [],
        financerId: [],
        vizId: "",
        invoiceNo: "",
        loanId: "",
        status: null,
        fromDate: new Date(),
        toDate: new Date(),
        pageNo: 0,
        searchText: null,
      });
    }
  }

  function formRequestObject() {
    let requestData = {
      distId: toCommaSeparated(filter.distId),
      distCenterId: toCommaSeparated(filter.distCenterId),
      financerId: toCommaSeparated(filter.financerId),
      vizId: filter.vizId,
      invoiceNo: filter.invoiceNo,
      loanId: filter.loanId,
      status: filter.status?.value,
      fromDate: filter.fromDate && formatDate(filter.fromDate),
      toDate: filter.fromDate && formatDate(filter.toDate),
      pageSize: currentPageSize,
      pageNo: currentPageNo,
      searchText: searchText,
    };
    if (userRights != null && userRights?.userType == "DistributorUser") {
      requestData = {
        ...requestData,
        distId: userRights?.distributorId,
      };
    }
    return requestData;
  }

  function fetchReportData(request) {
    let finalRequest = request == null ? formRequestObject() : request;
    props.getDisbursementFormList(finalRequest);
  }

  const handleResetFilters = (resetForm) => {
    resetForm();
    commonReset();
  };

  const getData = (page) => {
    setCurrentPageNo(page);
    var request = { ...formRequestObject(), pageNo: page };
    fetchReportData(request);
  };

  const pageSizeChanged = (pageSize) => {
    setCurrentPageNo(0);
    setCurrentPageSize(pageSize);
    var request = { ...formRequestObject(), pageSize: pageSize };
    fetchReportData(request);
  };

  useEffect(() => {
    setCurrentPageNo(0);
    fetchReportData();
  }, [searchText]);

  useEffect(() => {
    props.getDropdownList(
      `api/Distributor/GetDistributorsDDL`,
      GET_DISTRIBUTOR_DDL
    );
  }, []);

  useEffect(() => {
    if (userRights != null && userRights?.userType == "DistributorUser") {
      let distributorList = props.allDistributorList.filter(
        (x) => x.value == userRights?.distributorId
      );
      if (distributorList?.length > 0) {
        setfilter({
          ...filter,
          distId: {
            label: distributorList[0]?.label,
            value: distributorList[0]?.value,
          },
        });
      }
      setDistributorList(
        distributorList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        })
      );
    } else {
      setDistributorList(
        props.allDistributorList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        })
      );
    }
  }, [props.allDistributorList]);

  useEffect(() => {
    if (userRights != null && userRights?.userType == "DistributorUser") {
      let distCenterList = props.selectedAddJobDistCentersList.filter((x) =>
        userRights?.distCenterIds.includes(x.value)
      );
      setdistCenterList(
        distCenterList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        })
      );
    } else {
      setdistCenterList(
        props.selectedAddJobDistCentersList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        })
      );
    }
  }, [props.selectedAddJobDistCentersList]);

  useEffect(() => {
    if (!filter.distId || filter.distId.length > 0) {
      props.getDropdownListByPost(
        `api/DistCenter/GetDistCentersDDL`,
        { distributorIds: toCommaSeparated(filter.distId) },
        GET_ADDJOB_DISTRIBUTIONCENTER_DDL
      );
    } else {
      filter.distCenterId = [];
      setdistCenterList([]);
    }
  }, [filter.distId]);

  useEffect(() => {
    if (
      props.DisbursementFormList &&
      props.DisbursementFormList.totalRecords > 0
    ) {
      setTotalRecords(props.DisbursementFormList.totalRecords);
    } else {
      setTotalRecords(0);
    }
  }, [props.DisbursementFormList]);

  useEffect(() => {
    props.getDropdownList(`api/Lender/GetLendersDDL`, GET_LENDER_DDL);
  }, []);

  useEffect(() => {
    setLenderOptions(
      props.allLenderList.map(function (item) {
        return {
          value: item.value,
          label: item.label,
        };
      })
    );
  }, [props.allLenderList]);

  const searchChanged = (text) => {
    setSearchText(text);
  };

  const LoadDataByfilter = (event) => {
    setCurrentPageNo(0);
    var request = { ...formRequestObject(), pageNo: 0 };
    fetchReportData(request);
    setShow(false);
    setIsApplyFilter(true);
  };

  const handleClickCancel = (id) => {
    setModalShow(false);
    confirmAlert({
      closeOnEscape: true,
      closeOnClickOutside: true,
      customUI: ({ onClose }) => {
        return (
          <div className="custom-ui">
            <Modal.Dialog>
              <Modal.Header id="customized-dialog-title">
                <Modal.Title>Confirm to Cancel</Modal.Title>
                <button
                  type="button"
                  onClick={() => onClose()}
                  className="btn-close"
                  aria-label="No"
                ></button>
              </Modal.Header>
              <Modal.Body dividers>
                <p>Are you sure you want to cancel this?</p>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  onClick={() => {
                    CancelLoan(id);
                    onClose();
                  }}
                  variant="outline-primary"
                >
                  Yes, Cancel it!
                </Button>
                <Button
                  variant="primary"
                  onClick={() => {
                    onClose();
                    setModalShow(true);
                  }}
                  className="btn btn-primary"
                >
                  No
                </Button>
              </Modal.Footer>
            </Modal.Dialog>
          </div>
        );
      },
    });
  };

  const CancelLoan = async (id) => {
    await props.cancelLoan(id);
    fetchReportData();
  };

  const handleClickrejectedLoanIntrnalApply = (id) => {
    setModalShow(false);
    confirmAlert({
      closeOnEscape: true,
      closeOnClickOutside: true,
      customUI: ({ onClose }) => {
        return (
          <div className="custom-ui">
            <Modal.Dialog>
              <Modal.Header id="customized-dialog-title">
                <Modal.Title>Confirm to action</Modal.Title>
                <button
                  type="button"
                  onClick={() => onClose()}
                  className="btn-close"
                  aria-label="No"
                ></button>
              </Modal.Header>
              <Modal.Body dividers>
                <p>Are you sure you want to do this?</p>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  onClick={() => {
                    rejectedLoanIntrnalApplyAction(id);
                    onClose();
                  }}
                  variant="outline-primary"
                >
                  Yes, do it!
                </Button>
                <Button
                  variant="primary"
                  onClick={() => {
                    onClose();
                    setModalShow(true);
                  }}
                  className="btn btn-primary"
                >
                  No
                </Button>
              </Modal.Footer>
            </Modal.Dialog>
          </div>
        );
      },
    });
  };

  const rejectedLoanIntrnalApplyAction = async (id) => {
    await props.rejectedLoanIntrnalApply(id);
    fetchReportData();
  };

  const columns = [
    {
      Header: "Date",
      accessor: "dateOfSubmission",
      Cell: (row) => (
        <div style={{ width: "75px" }}>
          <Moment format="DD/MM/YYYY">{row.value}</Moment>
        </div>
      ),
    },
    {
      Header: "Lender",
      accessor: "financer",
    },
    {
      Header: "VIZ ID",
      accessor: "vizId",
    },
    {
      Header: "Shop Name",
      accessor: "shopName",
    },
    {
      Header: "Invoice #",
      accessor: "invoiceNo",
    },
    {
      Header: "Loan ID",
      accessor: "loanId",
    },

    {
      Header: "Status",
      accessor: "loanStatus",
    },
    {
      Header: renderHeader("Invoice Amount"),
      accessor: "invoiceAmount",
      Cell: ({ value }) => renderCell(value, true),
    },
    {
      Header: "Action",
      id: "edit",
      accessor: "id",
      Cell: ({ row: { original } }) => (
        <div style={{ width: "106px" }}>
          <button onClick={() => View(original.id)} className=" btn btn-sm">
            <i className="fas fa-eye"></i>
          </button>
          &nbsp;
          <button
            style={{
              display: original.loanStatus === "Rejected" ? "inline" : "none",
            }}
            onClick={() => Edit(original.id)}
            className="btn btn-sm"
          >
            <i className="fas fa-edit"></i>
          </button>
        </div>
      ),
    },
  ];

  const getRecord = (id) => {
    axios
      .get(`api/LenderFinancing/GetDisbursementFormDetail/${id}`)
      .then(({ data }) => {
        setSelectedDisbursement(data?.response);
        setOriginalDisbursementData({ ...data?.response });
        console.log(disbursementDetail);
        console.log(data?.response);
        setDisbursementDetail({ ...data?.response });
      })
      .catch(function (error) { });
  };

  const View = (id) => {
    setReadOnly(true);
    setModalShow(true);
    getRecord(id);
  };
  const Edit = (id) => {
    setReadOnly(false);
    setModalShow(true);
    getRecord(id);
  };

  const loanStatusOptions = [
    {
      label: "Under Review",
      value: 1,
    },
    {
      label: "Need More Info",
      value: 2,
    },
    {
      label: "Rejected",
      value: 3,
    },
    {
      label: "Canceled",
      value: 4,
    },
    {
      label: "Approved",
      value: 5,
    },
    {
      label: "Disbursed",
      value: 6,
    },
    {
      label: "Completed",
      value: 7,
    },
    {
      label: "Error",
      value: 8,
    },
    {
      label: "InternalApproved",
      value: 9,
    },
    {
      label: "InternalCompleted",
      value: 10,
    },
  ];

  const openUploadImage = (img) => {
    setSelectedImg(img);
    imgUploadRef.current.click();
  };

  const removeImage = (fieldName) => {
    disbursementDetail[fieldName] = "";
  };

  const saveImage = (event) => {
    dispatch(showLoading());
    const extension = getImageExtensions();
    if (event.target.files.length > 0) {
      let currentExtension = event.target.files[0].name.split('.').pop().toLowerCase();
      if (!extension.includes(currentExtension)) {
        dispatch(hideLoading());
        toast.error("Selected invalid file extension");
        return;
      }
      uploadFile(event.target.files[0])
        .then((response) => {
          dispatch(hideLoading());
          imgUploadRef.current.value = null;
          disbursementDetail[selectedImg] = response;
          setSelectedImg("");
        })
        .catch(function (error) {
          imgUploadRef.current.value = null;
          dispatch(hideLoading());
          toast.error(error);
        });
    } else {
      dispatch(hideLoading());
    }
  };

  const saveHandler = async (data) => {
    let _data = {
      id: selectedDisbursement.id,
      stockImageUrl: data.stockImageUrl,
      invoiceImageUrl: data.invoiceImageUrl,
    };

    await props.updateDisbursementForm(_data);

    fetchReportData();

    setModalShow(false);
  };

  return (
    <VzPageContainer title="Financing > Disbursement Form List">
      <Row>
        <Col style={{ float: "left" }}>
          <h4>
            <b>DISBURSEMENT FORM LIST</b>
          </h4>
          <br />
        </Col>
      </Row>
      <Row>
        <Col md={10} style={{ float: "right" }}>
          <div ref={ref}>
            <Button
              onClick={openFilterModal}
              className="m-3"
              variant="outline-primary"
            >
              <i className="fa fa-filter" />
              Filters
            </Button>

            <Overlay
              show={show}
              target={target}
              placement="bottom"
              container={ref}
              containerPadding={20}
              width="430px"
              style={{ width: "430px" }}
            >
              <Popover
                id="popover-contained"
                style={{ maxWidth: "360px", width: "360px" }}
              >
                <Popover.Header as="h3">Filters</Popover.Header>
                <Popover.Body>
                  <Formik
                    enableReinitialize
                    initialValues={filter}
                    validator={() => ({})}
                    onSubmit={LoadDataByfilter}
                  >
                    {(formik) => (
                      <Form autoComplete="off">
                        <Row>
                          {userRights == null && (
                            <Col xs={12} md={12}>
                              <FormikControl
                                formik={formik}
                                control="react-select"
                                label="Distributor"
                                name="distributor"
                                options={distributorList}
                                isMulti={true}
                                isClearable={true}
                                isSearchable={true}
                                handleOnChange={(e) => {
                                  setfilter({
                                    ...filter,
                                    distId: e || [],
                                    distCenterId: [],
                                  });
                                }}
                                value={filter.distId}
                              />
                            </Col>
                          )}

                          <Col xs={12} md={12}>
                            <FormikControl
                              formik={formik}
                              control="react-select"
                              label="Distribution Center"
                              name="distCenter"
                              options={
                                filter.distId != null ? distCenterList : []
                              }
                              isMulti={true}
                              isClearable={true}
                              isSearchable={true}
                              handleOnChange={(e) => {
                                setfilter({
                                  ...filter,
                                  distCenterId: e || [],
                                });
                              }}
                              value={filter.distCenterId}
                            />
                          </Col>
                          <Col xs={12} md={12}>
                            <FormikControl
                              formik={formik}
                              control="react-select"
                              label="Lender"
                              name="lender"
                              options={lenderOptions}
                              isMulti={true}
                              isClearable={true}
                              isSearchable={true}
                              handleOnChange={(e) => {
                                setfilter({
                                  ...filter,
                                  financerId: e || [],
                                });
                              }}
                              value={filter.financerId}
                            />
                          </Col>
                          <Col xs={12} md={12}>
                            <FormikControl
                              formik={formik}
                              control="input"
                              type="text"
                              label="Viz ID"
                              name="vizId"
                              handleOnChange={(e) => {
                                filter.vizId = e;
                                setfilter({ ...filter, vizId: AllowOnlyAlphaNumericWithDash(e) });
                              }}
                              value={filter.vizId}
                            />
                          </Col>
                          <Col xs={12} md={12}>
                            <FormikControl
                              formik={formik}
                              control="input"
                              type="text"
                              label="Invoice No"
                              name="invoiceNo"
                              handleOnChange={(e) => {
                                filter.invoiceNo = e;
                                setfilter({ ...filter, invoiceNo: e });
                              }}
                              value={filter.invoiceNo}
                            />
                          </Col>
                          <Col xs={12} md={12}>
                            <FormikControl
                              formik={formik}
                              control="input"
                              type="text"
                              label="Loan ID"
                              name="loanId"
                              handleOnChange={(e) => {
                                filter.loanId = e;
                                setfilter({ ...filter, loanId: e });
                              }}
                              value={filter.loanId}
                            />
                          </Col>
                          <Col xs={12} md={12}>
                            <FormikControl
                              formik={formik}
                              control="react-select"
                              label="Status"
                              name="loanStatus"
                              options={loanStatusOptions}
                              isClearable={true}
                              isSearchable={true}
                              handleOnChange={(e) => {
                                if (!e || !e.value) {
                                  setfilter({
                                    ...filter,
                                    status: null,
                                  });
                                  return;
                                }
                                setfilter({
                                  ...filter,
                                  status: {
                                    label: e.label,
                                    value: e.value,
                                  },
                                });
                              }}
                              value={filter.status}
                            />
                          </Col>
                          <Row style={{ paddingRight: 0 }}>
                            <Col xs={12} md={6}>
                              <FormikControl
                                formik={formik}
                                type="fromDate"
                                control="date"
                                label="From Date"
                                name="fromDate"
                                handleOnChange={(value) => {
                                  setfilter({ ...filter, fromDate: value });
                                }}
                                value={filter.fromDate}
                              />
                            </Col>
                            <Col xs={12} md={6}>
                              <FormikControl
                                formik={formik}
                                control="date"
                                type="toDate"
                                label="To Date"
                                name="toDate"
                                handleOnChange={(value) => {
                                  setfilter({ ...filter, toDate: value });
                                }}
                                value={filter.toDate}
                              />
                            </Col>
                          </Row>
                        </Row>
                        <div className="row" style={{ marginTop: 20 }}>
                          <div className="form-group">
                            <Link
                              onClick={handleResetFilters.bind(
                                null,
                                formik.resetForm,
                                setIsApplyFilter(false)
                              )}
                              to="#"
                              className="active"
                              style={{
                                padding: "0px",
                                marginTop: "10px",
                                float: "left",
                              }}
                            >
                              Reset
                            </Link>
                            <Link
                              onClick={() => {
                                setShow(false);
                                setTarget(null);
                                commonReset(isApplyFilter);
                              }}
                              to="#"
                              className="active"
                              style={{
                                padding: "0px",
                                marginTop: "10px",
                                float: "right",
                              }}
                            >
                              Cancel
                            </Link>
                            <div className="float-right">
                              <Button
                                type="submit"
                                className="btn btn-primary"
                                style={{
                                  marginRight: "10px",
                                  float: "right",
                                }}
                              >
                                Apply
                              </Button>
                            </div>
                          </div>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </Popover.Body>
              </Popover>
            </Overlay>
          </div>
        </Col>

        {/* =============================|| Add New Loan - START ||============================= */}
        <Modal
          show={showNewLoanPopup}
          onHide={() => setshowNewLoanPopup(false)}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>Loan Detail</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <NewLoanForm
              onClose={() => setshowNewLoanPopup(false)}
              getDropdownList={props.getDropdownList}
              allLenderList={props.allLenderList}
              allLoanPlanList={props.allLoanPlanList}
              applyNewLoan={props.applyNewLoan}
            />
          </Modal.Body>
        </Modal>

        {isPermittedPage('Apply New', props.actions, props.userRole) && (
          <Col>
            <div className='form-group'>
              <Button
                onClick={() => setshowNewLoanPopup(true)}
                className='form-btn'
                variant='outline-primary'
              >
                <i className='fa fa-plus' /> Apply New
              </Button>
            </div>
          </Col>
        )}
        {/* =============================|| Add New Loan - END ||=============================== */}


      </Row>
      <Row>
        <Col>
          <ServerSideDataTable
            data={props.DisbursementFormList?.data ?? []}
            columns={columns}
            getTrProps={(event, data) => null}
            goToPreviousPage={(val) => getData(val)}
            goToNextPage={(val) => getData(val)}
            totalRecords={totalRecords}
            pageSizeChange={(size) => pageSizeChanged(size)}
            myPageSize={currentPageSize}
            myIndex={currentIndex}
            pageNo={currentPageNo}
            searchChanged={searchChanged}
          />
        </Col>
      </Row>

      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        backdrop="static"
        keyboard={false}
        size="xl"
      >
        <Formik enableReinitialize initialValues={disbursementDetail}>
          {(formik) => (
            <Form
              autoComplete="off"
              encType="multipart/form-data"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
            >
              <Modal.Header closeButton>
                <Modal.Title
                  id="contained-modal-title-vcenter"
                  className="text-primary"
                >
                  Disbursement Listing:
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Container>
                  <Row>
                    <Col xs={12} md={8}>
                      <Container>
                        <Row>
                          <Col xs={12} md={12}>
                            <label
                              className="text-primary"
                              style={{ marginBottom: 0 }}
                            >
                              Main Info
                            </label>
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={12} md={6}>
                            <div className="form-group">
                              <FormikControl
                                formik={formik}
                                control="input"
                                label="Date"
                                name="mdate"
                                readOnly="true"
                                value={disbursementDetail.date}
                              />
                            </div>
                          </Col>
                          <Col xs={12} md={6}>
                            <div className="form-group">
                              <FormikControl
                                formik={formik}
                                control="input"
                                label="VIZ ID"
                                name="mvizId"
                                readOnly="true"
                                value={disbursementDetail.vizId}
                              />
                            </div>
                          </Col>
                          <Col xs={12} md={6}>
                            <div className="form-group">
                              <FormikControl
                                formik={formik}
                                control="input"
                                label="External Id"
                                name="mExternalId"
                                readOnly="true"
                                value={disbursementDetail.externalId}
                              />
                            </div>
                          </Col>
                          <Col xs={12} md={6}>
                            <div className="form-group">
                              <FormikControl
                                formik={formik}
                                control="input"
                                label="Loan Id"
                                name="mloanDisplayName"
                                readOnly="true"
                                value={disbursementDetail.loanDisplayName}
                              />
                            </div>
                          </Col>
                          <Col xs={12} md={6}>
                            <div className="form-group">
                              <FormikControl
                                formik={formik}
                                control="input"
                                label="Shop Code"
                                name="mshopCode"
                                readOnly="true"
                                value={disbursementDetail.shopCode}
                              />
                            </div>
                          </Col>
                          <Col xs={12} md={6}>
                            <div className="form-group">
                              <FormikControl
                                formik={formik}
                                control="input"
                                label="Shop Name"
                                name="mshopName"
                                readOnly="true"
                                value={disbursementDetail.shopName}
                              />
                            </div>
                          </Col>
                          <Col xs={12} md={6}>
                            <div className="form-group">
                              <FormikControl
                                formik={formik}
                                control="input"
                                label="Repayment Status"
                                name="mrepaymentStatus"
                                readOnly="true"
                                value={disbursementDetail.repaymentStatus}
                              />
                            </div>
                          </Col>
                          <Col xs={12} md={6}>
                            <div className="form-group">
                              <FormikControl
                                formik={formik}
                                control="input"
                                label="Loan Status"
                                name="mloanStatus"
                                readOnly="true"
                                value={disbursementDetail.loanStatus}
                              />
                            </div>
                          </Col>
                          <Col xs={12} md={6}>
                            <div className="form-group">
                              <FormikControl
                                formik={formik}
                                control="input"
                                label="Reason"
                                name="mreason"
                                readOnly="true"
                                value={disbursementDetail.reason}
                              />
                            </div>
                          </Col>
                          <Col xs={12} md={6}>
                            <div className="form-group">
                              <FormikControl
                                formik={formik}
                                control="input"
                                label="Response Time & Date"
                                name="mresponseDateTime"
                                readOnly="true"
                                value={disbursementDetail.responseDateTime}
                              />
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={12} md={12}>
                            <label
                              className="text-primary"
                              style={{ marginBottom: 0 }}
                            >
                              Invoice Info
                            </label>
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={12} md={6}>
                            <div className="form-group">
                              <FormikControl
                                formik={formik}
                                control="input"
                                label="invoice Date"
                                name="minvoiceDate"
                                readOnly="true"
                                value={disbursementDetail.invoiceDate}
                              />
                            </div>
                          </Col>
                          <Col xs={12} md={6}>
                            <div className="form-group">
                              <FormikControl
                                formik={formik}
                                control="input"
                                label="Invoice #"
                                name="minvoiceNumber"
                                readOnly="true"
                                value={disbursementDetail.invoiceNumber}
                              />
                            </div>
                          </Col>
                          <Col xs={12} md={6}>
                            <div className="form-group">
                              <FormikControl
                                formik={formik}
                                control="input"
                                label="Invoice Amount"
                                name="minvoiceAmount"
                                readOnly="true"
                                value={disbursementDetail.invoiceAmount}
                              />
                            </div>
                          </Col>
                          <Col xs={12} md={6}>
                            <div className="form-group">
                              <FormikControl
                                formik={formik}
                                control="input"
                                label="DeliveryMan"
                                name="mdeliveryMan"
                                readOnly="true"
                                value={disbursementDetail.deliveryMan}
                              />
                            </div>
                          </Col>
                          <Col xs={12} md={6}>
                            <div className="form-group">
                              <FormikControl
                                formik={formik}
                                control="input"
                                label="Finance Required"
                                name="mfinanceRequired"
                                readOnly="true"
                                value={disbursementDetail.financeRequired}
                              />
                            </div>
                          </Col>
                          <Col xs={12} md={6}>
                            <div className="form-group">
                              <FormikControl
                                formik={formik}
                                control="input"
                                label="Tenor"
                                name="mtenor"
                                readOnly="true"
                                value={disbursementDetail.tenor}
                              />
                            </div>
                          </Col>
                          <Col xs={12} md={6}>
                            <div className="form-group">
                              <FormikControl
                                formik={formik}
                                control="input"
                                label="Profit"
                                name="mprofit"
                                readOnly="true"
                                value={disbursementDetail.profit}
                              />
                            </div>
                          </Col>
                          <Col xs={12} md={6}>
                            <div className="form-group">
                              <FormikControl
                                formik={formik}
                                control="input"
                                label="Net Payable"
                                name="mnetPayable"
                                readOnly="true"
                                value={disbursementDetail.netPayable}
                              />
                            </div>
                          </Col>
                          <Col xs={12} md={6}>
                            <div className="form-group">
                              <FormikControl
                                formik={formik}
                                control="input"
                                label="Due Date"
                                name="mdueDate"
                                readOnly="true"
                                value={disbursementDetail.dueDate}
                              />
                            </div>
                          </Col>
                        </Row>
                      </Container>
                    </Col>
                    <Col xs={12} md={4}>
                      <Container>
                        <Row>
                          <Col xs={12} md={12}>
                            <label
                              className="text-primary"
                              style={{ marginBottom: 0 }}
                            >
                              Images
                            </label>
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={12} md={12} style={{ textAlign: "center" }}>
                            <label style={{ marginBottom: 0 }}>
                              STOCK PICTURE
                            </label>
                          </Col>
                          <Col xs={12} md={12}>
                            <div className="form-group  ">
                              <div className="d-flex flex-column align-items-center">
                                <img
                                  style={{ border: "1px solid #ccc" }}
                                  alt="not found"
                                  width={"100%"}
                                  height={"300px"}
                                  src={
                                    disbursementDetail?.stockImageUrl ||
                                    PlaceholderImage
                                  }
                                />
                                <input
                                  ref={imgUploadRef}
                                  hidden
                                  type="file"
                                  name="imageFile"
                                  accept="image/*"
                                  onChange={(event) => saveImage(event)}
                                />
                              </div>
                              <div className="d-flex  justify-content-center ms-2">
                                <button
                                  onClick={() =>
                                    openUploadImage("stockImageUrl")
                                  }
                                  className=" btn btn-sm m-2"
                                  hidden={readOnly}
                                >
                                  <i className="fas fa-edit"></i>
                                </button>
                                {/* &nbsp; */}
                                <button
                                  onClick={() => removeImage("stockImageUrl")}
                                  style={{ display: "none" }}
                                  className="btn btn-sm m-2"
                                  hidden={readOnly}
                                >
                                  <i className="fas fa-trash"></i>
                                </button>
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <Row style={{ marginTop: 60 }}>
                          <Col xs={12} md={12} style={{ textAlign: "center" }}>
                            <label style={{ marginBottom: 0 }}>
                              INVOICE PICTURE
                            </label>
                          </Col>
                          <Col xs={12} md={12}>
                            <div className="form-group  ">
                              <div className="d-flex flex-column align-items-center">
                                <img
                                  style={{ border: "1px solid #ccc" }}
                                  alt="not found"
                                  width={"100%"}
                                  height={"300px"}
                                  src={
                                    disbursementDetail?.invoiceImageUrl ||
                                    PlaceholderImage
                                  }
                                />
                                <input
                                  ref={imgUploadRef}
                                  hidden
                                  type="file"
                                  name="imageFile"
                                  accept="image/*"
                                  onChange={(event) => saveImage(event)}
                                />
                              </div>
                              <div className="d-flex  justify-content-center ms-2">
                                <button
                                  onClick={() =>
                                    openUploadImage("invoiceImageUrl")
                                  }
                                  className=" btn btn-sm m-2"
                                  hidden={readOnly}
                                >
                                  <i className="fas fa-edit"></i>
                                </button>
                                {/* &nbsp; */}
                                <button
                                  onClick={() => removeImage("invoiceImageUrl")}
                                  style={{ display: "none" }}
                                  className="btn btn-sm m-2"
                                  hidden={readOnly}
                                >
                                  <i className="fas fa-trash"></i>
                                </button>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Container>
                    </Col>
                  </Row>
                </Container>
              </Modal.Body>
              <Modal.Footer>
                {readOnly === false ? (
                  <>
                    <input
                      style={{ marginRight: "auto" }}
                      type="button"
                      className="btn btn-danger"
                      value="Cancel Loan"
                      onClick={() =>
                        handleClickCancel(disbursementDetail.loanDisplayName)
                      }
                    />
                    <input
                      style={{ marginRight: "auto" }}
                      type="button"
                      className="btn btn-danger"
                      value="Internal Apply"
                      onClick={() =>
                        handleClickrejectedLoanIntrnalApply(
                          disbursementDetail.loanDisplayName
                        )
                      }
                    />
                    <input
                      type="button"
                      className="btn btn-primary"
                      value="Save"
                      onClick={() => saveHandler(disbursementDetail)}
                    />
                  </>
                ) : (
                  <></>
                )}
                <Button
                  className="btn btn-default"
                  onClick={() => setModalShow(false)}
                >
                  Close
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </VzPageContainer>
  );
};

const mapStateToProps = (state) => {
  return {
    allDistributorList: state.ddlList.allDistributorList
      ? state.ddlList.allDistributorList
      : [],
    selectedAddJobDistCentersList: state.ddlList.selectedAddJobDistCentersList
      ? state.ddlList.selectedAddJobDistCentersList
      : [],
    allLenderList: state.ddlList.lenderList ? state.ddlList.lenderList : [],
    allLoanPlanList: state.ddlList.loanPlanList ? state.ddlList.loanPlanList : [],
    DisbursementFormList: state.DisbursementFormList,
  };
};
export default connect(mapStateToProps, {
  getDisbursementFormList,
  updateDisbursementForm,
  getDropdownList,
  getDropdownListByPost,
  cancelLoan,
  rejectedLoanIntrnalApply,
  applyNewLoan
})(DisbursementFormList);
